"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleaseOutside = void 0;
var React = __importStar(require("react"));
var defaultProps = {
    escapeCanRelease: false,
};
var ReleaseOutside = /** @class */ (function (_super) {
    __extends(ReleaseOutside, _super);
    function ReleaseOutside() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inside: false,
        };
        _this.onReleaseOutside = function () {
            if (!_this.state.inside) {
                _this.props.onRelease();
            }
        };
        _this.onEscape = function (event) {
            if (event.key === "Escape" && _this.props.escapeCanRelease) {
                _this.props.onRelease();
            }
        };
        _this.onMouseEnter = function () {
            _this.setState(function () { return ({
                inside: true,
            }); });
        };
        _this.onMouseLeave = function () {
            _this.setState(function () { return ({
                inside: false,
            }); });
        };
        _this.setupListeners = function () {
            window.addEventListener("keyup", _this.onEscape);
            window.addEventListener("mouseup", _this.onReleaseOutside);
        };
        _this.removeListeners = function () {
            window.removeEventListener("keyup", _this.onEscape);
            window.removeEventListener("mouseup", _this.onReleaseOutside);
        };
        return _this;
    }
    ReleaseOutside.prototype.componentDidMount = function () {
        this.setupListeners();
    };
    ReleaseOutside.prototype.componentWillUnmount = function () {
        this.removeListeners();
    };
    ReleaseOutside.prototype.render = function () {
        var children = this.props.children;
        var props = __rest(children.props, []);
        var mouseEvents = {
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
        };
        return React.cloneElement(children, __assign(__assign({}, mouseEvents), props));
    };
    ReleaseOutside.defaultProps = defaultProps;
    return ReleaseOutside;
}(React.Component));
exports.ReleaseOutside = ReleaseOutside;
exports.default = ReleaseOutside;
//# sourceMappingURL=release-outside.js.map